export { useStoreLocationSearch, type StoreLocation } from './useStoreLocationSearch';
